import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Button, Input } from 'reactstrap';
import { Dispatch } from 'redux';
import { RootState } from '../../stores/store';
import { changeItemsPerPage, goToPage, nextPage, prevPage } from '../../stores/tables/actionCreators';
import { getLimit, getPaging, getStart } from '../../stores/tables/selectors';

interface Props extends LocalizeContextProps {
    tableKey: string;
    refresh: () => void;

    start: number;
    limit: number;
    count: number;

    currentPage: number;
    numberOfPages: number;
    hasPrevPage: boolean;
    hasNextPage: boolean;

    changeItemsPerPage: (itemsPerPage: number) => void;
    goToPage: (page: number) => void;
    nextPage: () => void;
    prevPage: () => void;
}

class TableNavigation extends React.Component<Props> {
    constructor(props: Props) {
        super(props);

        this.state = {
            currentPage: props.currentPage,
        };
    }

    public render() {
        const t = this.props.translate;
        return (
            <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                    {t('users.text.rows', {
                        from: (this.props.start + 1 || 1).toString(),
                        to: (Math.min(
                            (this.props.start) + this.props.limit,
                            this.props.count)
                        ).toString()
                    })}
                    <div className="inline-block">
                        <Input
                            name="limit"
                            type="select"
                            value={this.props.limit}
                            onChange={
                                this.handleLimitChange
                            }
                        >
                            <option>15</option>
                            <option>30</option>
                            <option>50</option>
                            <option>100</option>
                        </Input>
                    </div>
                    {t('users.text.rowsPerPage')}
                </div>
                <div className="d-flex align-items-center">
                    <div className="inline-block no-margin-right">
                        <Button
                            id="prev-btn"
                            disabled={!this.props.hasPrevPage}
                            onClick={() => {
                                this.props.prevPage();
                                this.props.refresh();
                            }}
                        >
                            <FontAwesomeIcon icon={['fal', 'arrow-left']}/>
                        </Button>
                    </div>
                    <div className="inline-block no-margin-right">
                        <Input
                            type="select"
                            name="page"
                            value={
                                Math.round(this.props.currentPage) + 1
                            }
                            onChange={this.handlePageChange}
                        >
                            <option key="1">1</option>
                            {(() => {
                                const options = [];
                                for (let i = 2; i <= this.props.numberOfPages; i++) {
                                    options.push(<option key={i}>{i}</option>);
                                }
                                return options;
                            })()}
                            {/* } */}
                        </Input>
                    </div>
                    <div className="inline-block">
                        <Button
                            id="next-btn"
                            disabled={!this.props.hasNextPage}
                            onClick={(e) => {
                                this.props.nextPage();
                                this.props.refresh();
                            }}
                        >
                            <FontAwesomeIcon icon={['fal', 'arrow-right']}/>
                        </Button>
                    </div>

                </div>
            </div>
        );
    }

    private handleLimitChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.props.changeItemsPerPage(parseInt(e.target.value, 10));
        this.props.refresh();
    }

    private handlePageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.props.goToPage(parseInt(e.target.value, 10) - 1);
        this.props.refresh();
    }
}

const mapStateToProps = (state: RootState, props: { tableKey: string }) => {
    const paging = getPaging(state, props.tableKey);
    return {
        count: paging.numberOfItems,
        limit: getLimit(state, props.tableKey),
        start: getStart(state, props.tableKey),

        currentPage: paging.currentPage,
        hasNextPage: paging.currentPage < paging.numberOfPages - 1,
        hasPrevPage: paging.currentPage > 0,
        numberOfPages: paging.numberOfPages,
    };
};

const mapDispatchToProps = (dispatch: Dispatch, props: { tableKey: string }) => ({
    changeItemsPerPage: (itemsPerPage: number) =>
        dispatch(changeItemsPerPage(props.tableKey, itemsPerPage)),
    goToPage: (pageNumber: number) => dispatch(goToPage(props.tableKey, pageNumber)),
    nextPage: () => dispatch(nextPage(props.tableKey)),
    prevPage: () => dispatch(prevPage(props.tableKey)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(TableNavigation));